import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { decodeToken, getToken, getUser, unsetToken } from '../services/auth';
import { actions as actionAuth } from './../redux/actions/auth';
import Header from './header/Header';
import Menu from './menu/Menu';
import Routes from './../routes/Routes';
import Footer from './footer/Footer';
const Base = () => {

    const token = getToken();
    const profile = useSelector(state => state.auth.profile);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const getSetProfile = useCallback(async () => {
        
        if (!profile._id) {
            
            const { decoded } = await decodeToken(token);
            if (decoded) {
                const profileData = await getUser(decoded.id);
                dispatch(actionAuth.setProfile(profileData));
                setLoading(false);
            } else {
                
                //unsetToken();
                setLoading(false);
            }
        } else {
           
            setLoading(false);
        }
    },[dispatch, profile, token]);


    useEffect(() => {
        getSetProfile();
    }, [getSetProfile]);
    return (

        <div className="App">
            {!loading &&
                <>
                    <Header />
                    <Menu />
                    <Routes />
                    <Footer />
                </>
            }
            {loading && "Carregando..."}
        </div>
    );
};

export default Base;